import React from 'react';
import type { ComponentProps } from 'react';
import type { Classes } from '@moonjellydigital/react-components/dist/types';
import { computeClasses } from '@moonjellydigital/react-components';

export interface PaneProps extends ComponentProps<'div'> {
  children?: React.ReactNode;
  classes?: Classes;
  tag?: 'div' | 'span' | 'main' | 'section' | 'aside';
}

export const Pane = ({ children, classes, tag = 'div' }: PaneProps) => {
  switch (tag) {
    case 'div':
      return (
        <div className={`sp-pane${computeClasses(classes)}`}>{children}</div>
      );
    case 'span':
      return (
        <span className={`sp-pane${computeClasses(classes)}`}>{children}</span>
      );
    case 'main':
      return (
        <main className={`sp-pane${computeClasses(classes)}`}>{children}</main>
      );
    case 'section':
      return (
        <section className={`sp-pane${computeClasses(classes)}`}>
          {children}
        </section>
      );
    case 'aside':
      return (
        <aside className={`sp-pane${computeClasses(classes)}`}>
          {children}
        </aside>
      );
    default:
      return (
        <div className={`sp-pane${computeClasses(classes)}`}>{children}</div>
      );
  }
};
